import actions from './UiActions';
import initialState from './UiInitialState';
import reducers from './UiReducer';

export default {
  actions,
  initialState,
  reducers,
};
